import React from "react";
import { useSelector } from "react-redux";
import IndexApp from "../../Components/IndexApp";
import { DV2 } from "../DeclarationV2/theme";
import DocumentsV2 from "../DocumentsV2/DocumentsV2";

/**
 * « Mes documents » du client repensé (espace client, 2 novembre 2026) : la
 * même liste que celle du prof (maquette 9a), limitée aux documents du
 * client, sans abonnements de transport ni filtre par élève. L'ancienne page
 * (`ClientDocuments`, `DocumentSpace`) reste dans le code.
 */
const ClientDocumentsV2 = () => {
    const client = useSelector((state: any) => state.user?.currentUser?.client);
    return (
        <IndexApp
            navBar={{ index: 2 }}
            component={
                <main className="px-4" style={{ background: DV2.pageBg, minHeight: "calc(100vh - 64px)" }}>
                    {client?.id ? <DocumentsV2 clientId={client.id} /> : null}
                </main>
            }
        />
    );
};

export default ClientDocumentsV2;
